import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SectionHeader from '@/components/SectionHeader';
import Spinner from '@/components/Spinner';
import { API } from '@/lib/utils';
import { useSEO } from '@/lib/useSEO';
import { ArrowRight, Lightning, Drop, Flame, Virus, ShieldWarning, ShieldCheck } from '@phosphor-icons/react';

const ICONS = { Lightning, Drop, Flame, Virus, ShieldWarning, ShieldCheck };

export default function EmergencyTypesList() {
  const [types, setTypes] = useState(null);

  useSEO({
    title: 'Alle noodsituaties',
    description: 'Bekijk alle crisisscenario\'s: stroomuitval, overstroming, brand, pandemie, oorlog en het algemene 72-uurs pakket. Per scenario de producten die je nodig hebt.',
    path: '/noodsituaties',
  });

  useEffect(() => {
    axios.get(`${API}/emergency-types`).then((r) => setTypes(Array.isArray(r.data) ? r.data : [])).catch(console.error);
  }, []);

  return (
    <div data-testid="page-emergency-types">
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-24">
          <SectionHeader
            eyebrow="Alle scenario's"
            title="Voor welke crisis wil jij klaar zijn?"
            description="Van stroomuitval tot overstroming — kies een scenario om te zien welke producten je nodig hebt."
            accent
          />
        </div>
      </section>
      <section className="container py-12 lg:py-16">
        {types === null ? <Spinner /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {(types || []).map((t) => {
              const Icon = ICONS[t.icon] || ShieldCheck;
              return (
                <Link
                  key={t.slug}
                  to={`/noodsituaties/${t.slug}`}
                  data-testid={`type-${t.slug}`}
                  className="group relative border border-border rounded-sm overflow-hidden bg-card hover:-translate-y-1 hover:shadow-lg transition-all"
                >
                  <div className="relative aspect-[4/3]">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                    <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, ${t.color}33 0%, ${t.color}aa 50%, ${t.color}ee 100%)` }} />
                    <div className="absolute top-4 left-4 w-10 h-10 bg-background/90 text-foreground rounded-sm flex items-center justify-center backdrop-blur">
                      <Icon weight="duotone" size={22} />
                    </div>
                  </div>
                  <div className="absolute bottom-0 inset-x-0 p-5 text-background">
                    <div className="overline text-background/80 mb-2">{t.short}</div>
                    <h3 className="font-display font-black text-2xl leading-tight">{t.name}</h3>
                    <div className="mt-3 text-sm font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                      Producten <ArrowRight size={16} weight="bold" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
